<!--
 * @Author: your name
 * @Date: 2021-08-13 17:04:31
 * @LastEditTime: 2022-03-03 15:43:21
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /my-activation/src/components/loading.vue
-->
<template>
  <div class="app">
    <div class="bor"></div>
    <div class="load">
      <vue-loading
        type="spin"
        color="#fff"
        :size="{ width: '50px', height: '50px' }"
      ></vue-loading>
      加载中
    </div>
  </div>
</template>
<script>
export default {
  name: "loading",
  data() {
    return {};
  }
};
</script>
<style scoped>
.app {
  width: 100%;
  height: 100%;
  z-index: 999999999999999;
}
.bor {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100px;
  height: 100px;
  margin-left: -50px;
  margin-top: -75px;
  opacity: 0.7;
  background: #000;
  border-radius: 8px;
}

.load {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100px;
  height: 100px;
  line-height: 100px;
  margin-left: -50px;
  margin-top: -75px;
  color: #fff;
  text-align: center;
  font-size: 13px;
  z-index: 99999999999999999999;
}
</style>



// WEBPACK FOOTER //
// src/components/loading.vue